import {
  DevicesCountWithUnresolvedIncidentsListNode,
  DevicesListNode,
} from '@/features/devices-table'
import {
  OrganisationFacilitiesListNode,
  OrganizationFacilitiesIncidentCountListNode,
} from '@/features/global-map'

interface FacilityWithFloorIdsI {
  defaultFloorId?: string
  floors?: { edges?: { node?: { id: string } }[] }
}

type NodeType =
  | OrganisationFacilitiesListNode
  | OrganizationFacilitiesIncidentCountListNode
  | DevicesListNode
  | DevicesCountWithUnresolvedIncidentsListNode

export const uuid = () =>
  (performance.now().toString(36) + Math.random().toString(36)).replace(
    /\./g,
    ''
  )
export const getMajorMinorVersion = (version: string): string => {
  const isMajorMinorPatchVersion = version?.split('.').length - 1 === 2
  if (isMajorMinorPatchVersion) {
    return version?.substring(0, version?.lastIndexOf('.'))
  }
  return version
}

export const getDefaultOrFirstFloorId = (
  facility: FacilityWithFloorIdsI
): string => facility?.defaultFloorId || facility.floors.edges[0]?.node?.id

// Ensure that all cases where handled in switch-case
// Reference: <https://www.meticulous.ai/blog/safer-exhaustive-switch-statements-in-typescript>
export const exhaustiveCheck = (switchArg: never) => {
  const exhaustiveCheck: never = switchArg
  throw new Error(`Unexpected type: ${exhaustiveCheck}`)
}

export const isValidTimestamp = (str: string) => !isNaN(Date.parse(str))

export const arraysMerged = <T = NodeType>(
  dataArray1: NodeType[],
  dataArray2: NodeType[]
): T[] => {
  if (!dataArray2 || dataArray2?.length === 0) {
    return dataArray1 as T[]
  }
  const combinedArray = dataArray1?.concat(dataArray2)
  const merged = {}
  combinedArray?.forEach((obj) => {
    const id = obj?.id
    if (!merged[id]) {
      merged[id] = { ...obj }
    } else {
      merged[id] = { ...merged[id], ...obj }
    }
  })
  return Object.values(merged)
}
